import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
  @Input() current: number;
  @Input() total: number;
  @Input() percent: number;
  @Input() label: string;
  @Input() isSubLabel: boolean;
  @Input() isCompound: boolean;
}



// WEBPACK FOOTER //
// ./ts/app/shared/progress-bar/progress-bar.component.ts